import BaseParser from './BaseParser';

export default class AllParagraphParser extends BaseParser {
	constructor(jquery: JQueryStatic, baseUrl: string) {
		super(jquery, baseUrl);
	}

	protected parseBody($agreement: JQuery, type: string): JQuery {
		const $body = $agreement;
		$body.find('[src*="images"]')
			.each((index, obj) => {
				let src = $(obj).attr('src');
				src = src.replace('images', '/content/dam/mylt/images');
				$(obj).attr('src', src);
			});

		return $body;
	}

	protected parsePdf(pdf: string, type: string): JQuery {
		return $(`<iframe style="overflow:hidden;height:100vh;width:100vw" src="data:application/pdf;base64,${pdf}"></iframe>`);
	}
}
